/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/* Storage */
import { selectChannelById } from '../storage/channels';

/* Utils */
import { PROVIDERS } from '../utils/constants';

export default function useChannel(channelId, sourceProvider = PROVIDERS.VRIO) {
  const channelSelector = useMemo(
    () => selectChannelById(`${channelId}-${sourceProvider}`),
    [channelId, sourceProvider],
  );

  return useSelector(channelSelector);
}
